import React, { Component } from 'react';
import styled from '@emotion/styled';
import colors from '../../../styling/colors';

const ContainerForm = styled.form`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 0.5rem 0.5rem 0.75rem;
  width: 13.75rem;
  height: 2.5rem;
  border: 1px solid ${colors('alto')};
  color: ${colors('mineshaft')};
`;

const TextInput = styled.input`
  border: none;
  display: block;
  height: 1.5rem;
  width: 100%;
  margin-right: 0.5rem;
  outline: none;
  font-size: 14px;

  &::placeholder {
    color: ${colors('Silver')};
  }
`;

const IconPositionContainer = styled.div`
  display: flex;
  align-self: center;
  position: relative;
`;

const HiddenSubmit = styled.input`
  cursor: pointer;
  border: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
`;

export default class TextInputWithIcon extends Component {
  render() {
    const { onSubmit, submitIcon, placeholder, defaultValue } = this.props;

    let handleSubmit = event => {
      event.preventDefault();
      onSubmit(this.input.value);
    };

    return (
      <ContainerForm onSubmit={handleSubmit}>
        <TextInput
          type="text"
          placeholder={placeholder}
          defaultValue={defaultValue}
          ref={inputRef => (this.input = inputRef)}
        />
        <IconPositionContainer>
          <HiddenSubmit name="commit" type="submit" value="" />
          {submitIcon}
        </IconPositionContainer>
      </ContainerForm>
    );
  }
}
